import { Place } from '@/types/google-maps.types';

export const defaultPlace: Place[] = [
  {
    placeId: 'ChIJ3bPNUVPj3JQRCejLuqVrL20',
    formattedAddress: 'Curitiba, PR, Brasil',
    latitude: -25.4372382,
    longitude: -49.2699727,
    types: ['locality', 'political'],
    city: 'Curitiba',
    state: 'PR',
  },
  {
    placeId: 'ChIJ0WGkg4FEzpQRrlsz_whLqZs',
    formattedAddress: 'São Paulo, SP, Brasil',
    latitude: -23.5557714,
    longitude: -46.6395571,
    types: ['locality', 'political'],
    city: 'São Paulo',
    state: 'SP',
  },
  {
    placeId: 'ChIJ1zLGsk45J5URRscEagtVvIE',
    formattedAddress: 'Florianópolis, SC, Brasil',
    latitude: -27.5948036,
    longitude: -48.5569286,
    types: ['locality', 'political'],
    city: 'Florianópolis',
    state: 'SC',
  },
  {
    placeId: 'ChIJbVivV1pD65QRcfkUxqURrCM',
    formattedAddress: 'Londrina, PR, Brasil',
    latitude: -23.3197305,
    longitude: -51.1662008,
    types: ['locality', 'political'],
    city: 'Londrina',
    state: 'PR',
  },
  {
    placeId: 'ChIJ-QsrE9nQ7JQR6PC8YweXpEk',
    formattedAddress: 'Maringá, PR, Brasil',
    latitude: -23.4209686,
    longitude: -51.9330844,
    types: ['locality', 'political'],
    city: 'Maringá',
    state: 'PR',
  },
];
